<template>
  <v-container class="col-12 col-md-8">
    <v-row justify="center" align="center">
      <v-col class="text-left" cols="6">
        <v-btn text tile color="" @click="$router.go(-1)">
          <v-icon left>mdi-arrow-left</v-icon> {{ $t('common.go-back') }}
        </v-btn>
      </v-col>
      <v-col class="text-right" cols="6">
        <v-btn
          tile
          outlined
          color="primary"
          @click="$vuetify.goTo('#job-form')"
        >
          {{ $t('careers.apply-now') }}
        </v-btn>
      </v-col>
      <v-skeleton-loader
        v-if="isLoading"
        width="100%"
        type="card-heading, divider, list-item-three-line, actions"
      ></v-skeleton-loader>
      <v-col v-else>
        <h1>{{ jobDetails.data.title[0].text }}</h1>
        <h2 class="subtitle-1">
          {{ jobDetails.data.city }}, {{ jobDetails.data.location }}
        </h2>
      </v-col>
    </v-row>
    <hr v-show="!isLoading" />
    <v-row v-show="!isLoading">
      <v-col>
        <prismic-rich-text :field="jobDetails.data.description"/>
      </v-col>
    </v-row>
    <hr v-show="!isLoading" />
      <v-form
        v-show="!isLoading"
        id="job-form"
        data-netlify="true"
        name="job-submission"
        data-netlify-honeypot="bot-field" method="post"
        netlify>
          <v-row>
            <v-col>
              <h2>Apply for this job</h2>
            </v-col>
          </v-row>
        <input type="hidden" name="bot-field" />
        <input type="hidden" name="form-name" value="job-submission" />
        <input type="hidden" name="job-name" :value="jobDetails.data.title[0].text" />
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                label="First Name"
                name="firstName"
                v-model="form.firstName" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                label="Last Name"
                name="lastName"
                v-model="form.lastName" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                label="Email"
                name="email"
                v-model="form.email" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                label="Phone"
                name="phone"
                v-model="form.phone" />
            </v-col>
            <v-col cols="6">
              <v-file-input
                label="Resume"
                name="resume"
              />
            </v-col>
            <div data-netlify-recaptcha="true"></div>
            <v-col cols="12">
              <v-btn class="float-right" outlined color="primary" large type="submit">Submit</v-btn>
            </v-col>
          </v-row>
      </v-form>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Job',
  data() {
    return {
      isLoading: true,
      jobDetails: {
        data: {
          title: [{
            text: '',
          }],
        },
      },
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      },
    };
  },
  methods: {
    getJobDetails() {
      this.$prismic.client.getByUID('jobs', this.$route.params.id).then((res) => {
        this.jobDetails = res;
        this.isLoading = false;
      });
    },
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`,
        )
        .join('&');
    },
    handleSubmit() {
      const axiosConfig = {
        header: { 'Content-Type': 'application/x-www-form-urlencoded' },
      };
      axios.post(
        '/',
        this.encode({
          'form-name': 'cv',
          ...this.form,
        }),
        axiosConfig,
      );
    },
  },
  created() {
    this.getJobDetails();
  },
};
</script>

<style scoped>

</style>
